import { h } from 'preact'
import Icon from '../assets'
import formatDateInLocalTimezone from '../utils/dateFormatting'

type Props = {
  title: string,
  editedAt: string | undefined,
  editedBy: string | undefined,
  url: string
}

export default ({ title, editedAt, editedBy, url }: Props) =>
  <div class='control-header'>
    <div class='article-versions__header'>
      <a href={url}>
        <Icon icon='arrowBack' color='#878787' />
      </a>
      <div class='article-versions__header-title'>
        <h2>{title}</h2>
        {editedAt && <div class='article-versions__header-metadata'>
          {formatDateInLocalTimezone(editedAt)} • Changes made by {editedBy}
        </div>}
      </div>
    </div>
  </div>
